import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { CheckboxInput } from '../../../Helpers/Inputs/index';
import ButtonInput from '../../../Helpers/Inputs/ButtonInput';
import HealthNotesIcon from '../../../../icons/health-notes.svg';
import ThermometerIcon from '../../../../icons/thermometer.svg';
import DnaIcon from '../../../../icons/Dna.svg';
import BeerIcon from '../../../../icons/Beer.svg';
import Button from '@material-ui/core/Button';

export default function HealthProfile(props) {
    const { register, handleSubmit, setValue } = useForm({
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    const checknoneOfTheAbove = (
        props.formState.personalHistoryMedical ||
        props.formState.hospitalized ||
        props.formState.familyHistory ||
        props.formState.treatedAlcoholSubstanceAbuse
    );

    useEffect(() => {
        register({ name: 'personalHistoryMedical' });
        setValue('personalHistoryMedical', props.formState.personalHistoryMedical);

        register({ name: 'hospitalized' });
        setValue('hospitalized', props.formState.hospitalized);

        register({ name: 'familyHistory' });
        setValue('familyHistory', props.formState.familyHistory);

        register({ name: 'treatedAlcoholSubstanceAbuse' });
        setValue('treatedAlcoholSubstanceAbuse', props.formState.treatedAlcoholSubstanceAbuse);
    }, [register])

    useEffect(() => {
        if (checknoneOfTheAbove && props.formState.noneApply) {
            props.onFieldChange('noneApply', false);
        } else if (!checknoneOfTheAbove && !props.formState.noneApply) {
            props.onFieldChange('noneApply', true);
        }
    }, [checknoneOfTheAbove]);

    const buttonData = [
        {
            icon: HealthNotesIcon,
            title: 'Personal history of any medical or health condition',
            value: props.formState.personalHistoryMedical,
            field: "personalHistoryMedical"
        },
        {
            icon: ThermometerIcon,
            title: 'Hospitalized within the last 2 years',
            value: props.formState.hospitalized,
            field: "hospitalized"
        },
        {
            icon: DnaIcon,
            title: 'Family history of cancer or cardiovascular disease before age 70',
            value: props.formState.familyHistory,
            field: "familyHistory"
        },
        {
            icon: BeerIcon,
            title: 'Treated for alcohol or drug abuse',
            value: props.formState.treatedAlcoholSubstanceAbuse,
            field: "treatedAlcoholSubstanceAbuse"
        }
    ];

    const handleValueChange = (field, value) => {
        props.onFieldChange(field, value);
    };

    const clearValues = () => {
        props.resetHealthProfileValues()
    };

    return (
        <Container fluid className='border-class'>
            <Row className="justify-content-center pt-5">
                <h4>Your client's health profile...</h4>
            </Row>
            <Row className="justify-content-center">
                <span>Our experts will help personalize the best coverage for your client.</span>
            </Row>
            <Form onSubmit={handleSubmit(props.onNext)}>
                <Row className="justify-content-center pt-3" role="group" aria-labelledby="Select Personalizing Options" >
                    {buttonData.map((d, index) =>
                        <Col md="auto" className="d-flex justify-content-center mb-3" key={index}>
                            <ButtonInput
                                icon={d.icon}
                                title={d.title}
                                subtitle={d.subtitle}
                                value={d.value}
                                onClick={() => handleValueChange(d.field, !d.value)}
                                mobileWide={true}
                            />
                        </Col>
                    )}
                </Row>

                <Row className="justify-content-center">
                    <CheckboxInput
                        id="none-apply"
                        onChange={clearValues}
                        checked={props.formState.noneApply}
                        name="none-apply"
                        inputRef={register}
                        label="None of these apply"
                    />
                </Row>
                <Row className="pt-5 mb-4 mx-2">
                    <Col className="text-left btn-back">
                        <Button variant="outlined" size="medium" color="primary" onClick={props.onBack} >BACK</Button>
                    </Col>
                    <Col className="text-right">
                        <Button variant="contained" size="medium" color="primary" type="submit" >NEXT</Button>
                    </Col>
                </Row>
            </Form>
        </Container>
    );
}

HealthProfile.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
};

HealthProfile.DefaultFormState = () => {
    return {
        personalHistoryMedical: false,
        hospitalized: false,
        familyHistory: false,
        treatedAlcoholSubstanceAbuse: false,
        noneApply: true
    };
};



// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/steps/HealthProfile.js